/****************************************************
 * Module Name:  TenderLotProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class TenderLotProxy {


    static GetAllCompanyTendersToEvaluate = (callback) => {

        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/evaluate",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForPlanning = (evaluate, tenderlotstatus, callback) => {

        let params = {
            evaluate: evaluate,
            tenderlotstatus: tenderlotstatus,
        }

        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/plan",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForSales = (evaluate, stonestaus, tenderlotstatus, callback) => {
        let params = {
            evaluate: evaluate,
            stonestaus: stonestaus,
            tenderlotstatus: tenderlotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/sell",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForManufacturingAndPreview = (evaluate, stonestaus, tenderlotstatus, tenderbidstatus, callback) => {
        let params = {
            evaluate: evaluate,
            stonestaus: stonestaus,
            tenderlotstatus: tenderlotstatus,
            tenderbidstatus: tenderbidstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/manufacturingpreview",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForDirectStoneBid = (evaluate, stonestaus, tenderlotstatus, callback) => {
        let params = {
            evaluate: evaluate,
            stonestaus: stonestaus,
            tenderlotstatus: tenderlotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/directbid",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForLotBid = (evaluate, stonestaus, tenderlotstatus, callback) => {
        let params = {
            evaluate: evaluate,
            stonestaus: stonestaus,
            tenderlotstatus: tenderlotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/lotbid",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompanyTendersForReport = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/company/report",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static TenderLotDataByCompany = (tenderid, companyid, evaluate, lotstatus, stonestatus, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
            evaluate: evaluate,
            lotstatus: lotstatus,
            stonestatus: stonestatus
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static TenderLotDataSell = (tenderid, companyid, evaluate, stonestatus, lotstatus, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
            evaluate: evaluate,
            stonestatus: stonestatus,
            lotstatus: lotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail/sell",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static TenderLotDataManufacturingPreview = (tenderid, companyid, evaluate, stonestatus, lotstatus, bidstatus, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
            evaluate: evaluate,
            stonestatus: stonestatus,
            lotstatus: lotstatus,
            bidstatus: bidstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail/manufacturingpreview",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static TenderLotDataDirectStoneBid = (tenderid, companyid, evaluate, stonestatus, lotstatus, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
            evaluate: evaluate,
            stonestatus: stonestatus,
            lotstatus: lotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail/directstonebid",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetCompletedLotData = (tenderid, companyid, evaluate, stonestatus, lotstatus, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
            evaluate: evaluate,
            stonestatus: stonestatus,
            lotstatus: lotstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail/completed",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UploadTenderLot = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static EvaluateTenderLots = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/evaluate",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddTenderLotResult = (data, result, callback) => {
        let params = {
            result: result,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/result",
            "post",
            Constants.userToken,
            params,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddRemark = (remark, stoneid, callback) => {

        let params = {
            stoneid: stoneid,
        }

        let body = JSON.stringify({ remark: remark || "" });

        restAPICall(
            Constants.MANAGER_URL + "/tenderstone/remark",
            "post",
            Constants.userToken,
            params,
            body,
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetImagesByStoneId = (
        stoneid,
        callback
    ) => {
        let params = {
            stoneid: stoneid,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderstone/image",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => { callback(response) })
            .catch((error) => { callback(undefined); });
    };


    static UploadTenderStoneImages = (data, stoneid, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tenderstone/upload/${stoneid}`,
            "post",
            Constants.userToken,
            undefined,
            data,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddStones = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + `/tenderstone`,
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetReportData = (tenderid, companyid, callback) => {
        let params = {
            tenderid: tenderid,
            companyid: companyid,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlot/detail/report",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}